import { Component, Inject } from "@angular/core";
import {
  NavController,
  AlertController,
  LoadingController,
  Loading
} from "ionic-angular";
import { AuthService } from "../../providers/auth-service";
import { DriverListPage } from "../../pages/dvm/driver/list/index";
import { ConfigurationService } from "ionic-configuration-service";
import { WhSummaryPage } from "../../pages/backoffice/overall/summary/index";
import { CommonModule } from "@angular/common";
import { TicketsPage } from "../backoffice/tickets";
import { SearchParcel } from "../qdb/search-parcel";
import { Storage } from "@ionic/storage";

interface AjaxResponse {
  code: number;
  data: Array<MenuItem>;
}

interface MenuItem {
  key: string;
  value: string;
}

@Component({
  selector: "page-login",
  templateUrl: "login.html"
})
export class LoginPage {
  loading: Loading;
  secretNumber: any;
  env: any;
  display: boolean;
  registerCredentials = { email: "", password: "" };

  constructor(
    private configurationService: ConfigurationService,
    private storage: Storage,
    private nav: NavController,
    private auth: AuthService,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController
  ) {
    this.env = this.configurationService.getValue<String>("APP_ENV");
    this.secretNumber = this.configurationService.getValue<String>(
      "VERSION_CODE"
    );

    if (this.env == "staging") {
      let registerCredentials = { email: "dm", password: "654321" };
    }
    this.display = false;
  }

  async login() {
    this.showLoading();
    try {
      if (
        this.registerCredentials.email === null ||
        this.registerCredentials.password === null
      ) {
        this.showError("Please insert credentials");
        return;
      }
      let res: any = await this.auth.login(this.registerCredentials);
      if (res.code == 1001) {
        await this.storage.set("jwt_token", res.data.token);
        console.log(this.registerCredentials);
        localStorage.setItem("user", this.registerCredentials.toString());
        let tagData: any = await this.auth.get_data("ticket/tag");
        this.auth.set_item("tagsData", tagData.data);
        let userInfo: any = await this.auth.get_data("user/detail");
        localStorage.setItem(
          "fuFilters",
          JSON.stringify(userInfo.data.filters)
        );
        localStorage.setItem("userInfoData", JSON.stringify(userInfo.data));
        await this.nav.setRoot(SearchParcel);
      } else if (res.code == 1002) {
        this.showError(res.msg);
      } else {
        this.showError("Access Denied");
      }
    } catch (error) {
      this.showError(error);
    }
  }

  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: "Please wait...",
      dismissOnPageChange: true
    });
    this.loading.present();
  }

  showError(text) {
    this.loading.dismiss();
    let alert = this.alertCtrl.create({
      title: "Fail",
      subTitle: text,
      buttons: ["OK"]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/user/login.ts